export const MINIMUM_NODE_MAJOR = 20;

export function unsupportedNodeRuntimeMessage(version: string): string | null {
  const major = Number.parseInt(version.split('.')[0] ?? '', 10);
  if (Number.isFinite(major) && major >= MINIMUM_NODE_MAJOR) return null;
  return `Cofactor requires Node.js ${MINIMUM_NODE_MAJOR} or newer (current: ${version}). Upgrade Node.js, or run this command with Bun.`;
}
